import { MissingTranslationHandlerParams, MissingTranslationHandler } from '@ngx-translate/core';

export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return params.translateService.instant('UNAVAILABLE');
  }

}
